import type { FC } from 'react';

import cn from 'classnames';

import Button from '@gds/Button/Button';
import { MultiSelect } from '@plp/Components/MultiSelect/MultiSelect';

import type { FilterControlBaseProps } from '../../FilterPanel.entity';
import SearchInput from '../SearchInput/SearchInput';
import useModelVariant from './UseModelVariant';

import styles from '../ModelFilter/ModelFilter.module.css';

type ModelVariantFilterProps = FilterControlBaseProps;

const ModelVariantFilter: FC<ModelVariantFilterProps> = ({
  locale,
  searchIsActive,
  strings,
  triggerSearch,
  isPlpFiltersSeoEnabled,
  tenant,
}) => {
  const {
    handleSelect,
    handleSearchChange,
    searchValue,
    filteredOptions,
    resetFilter,
    selectedOptions: selectedModelVariants,
    allOptions,
    isSearching,
  } = useModelVariant(locale, isPlpFiltersSeoEnabled, tenant);

  const containerClass = cn(styles.models, {
    [styles.searching]: searchIsActive,
  });

  return (
    <div>
      <SearchInput
        searchValue={searchValue}
        isSearching={isSearching}
        handleSearchChange={handleSearchChange}
        placeholder={strings.searchPlaceholder}
        triggerSearch={triggerSearch!}
        searchIsActive={searchIsActive!}
        parentId="variant"
      />
      <Button
        size="small"
        variant="link"
        onClick={resetFilter}
        disabled={selectedModelVariants.size === 0}
        className={styles.resetButton}
        dataTestId="reset-model-variant-filter"
      >
        {strings.reset}
      </Button>
      <div className={containerClass}>
        <MultiSelect
          groupName="model-variant"
          items={searchValue ? filteredOptions : allOptions}
          onSelect={handleSelect}
          dataTestId="model-variant-menu"
          noResultText={strings.noResults}
          groupBy="model"
          isGrouped
          keyAsTitle
          shouldOrder
        />
      </div>
    </div>
  );
};

export default ModelVariantFilter;
